import { get, post, put, patch, destroy } from "connection/api";
import * as url from "connection/urls";

// Authentication
export const postLogin = (data) => post(url.LOGIN, data);
export const getMe = () => get(url.ME);
export const postLogout = () => post(url.LOGOUT);

// Dashboard
export const getDashboardDetail = () => get(url.DASHBOARD);

// Users
export const postUserCreate = (data) => post(url.USERS, data);
export const getUserList = () => get(url.USERS);
export const getUserFilter = (changeUrl) =>
  get(`${url.USERS}${changeUrl.changeUrl}`);
export const getUserDetail = (id) => get(`${url.USERS}${id}/`);
export const patchUserUpdate = (id, data) =>
  patch(`${url.USERS}${id.id}/`, data);

// Clients
export const postClientCreate = (data) => post(url.CLIENTS, data);
export const getClientList = () => get(url.CLIENTS);
export const getClientFullList = () => get(url.CLIENT_LIST);
export const getClientDetail = (code) => get(`${url.CLIENTS}${code}/detail/`);
export const getClient = (code) => get(`${url.CLIENTS}${code}/`);
export const getClientFilter = (changeUrl) =>
  get(`${url.CLIENTS}${changeUrl.changeUrl}`);
export const patchClientUpdate = (id, data) =>
  patch(`${url.CLIENTS}${id.id}/`, data);
export const getClientPayment = (code) =>
  get(`${url.CLIENTS}${code}/${url.CLIENT_PAYMENT}`);
export const deleteClient = (id) => destroy(`${url.CLIENTS}${id}/`);

// Rates
export const getRateFullList = () => get(url.RATE_LIST);
export const getRateList = () => get(url.RATES);
export const postRateCreate = (data) => post(url.RATES, data);
export const getRateDetail = (id) => get(`${url.RATES}${id}/`);
export const getRateFilter = (changeUrl) =>
  get(`${url.RATES}${changeUrl.changeUrl}`);
export const putRateUpdate = (id, data) => put(`${url.RATES}${id.id}/`, data);
export const deleteRate = (id) => destroy(`${url.RATES}${id}/`);
export const patchBulkClientRate = (data) => patch(`${url.CLIENTS}bulk/`, data);

// Vehicles
export const postVehicleCreate = (data) => post(url.VEHICLES, data);
export const getVehicleList = () => get(url.VEHICLES);
export const getVehicleDetail = (id) => get(`${url.VEHICLES}${id}/`);
export const getVehicleFilter = (changeUrl) =>
  get(`${url.VEHICLES}${changeUrl.changeUrl}`);
export const getVehicleFullList = () => get(url.VEHICLE_LIST);
export const patchVehicleUpdate = (id, data) =>
  patch(`${url.VEHICLES}${id.id}/`, data);

// Billing
export const getTicketList = () => get(url.TICKETS);
export const postTicketCreate = (data) => post(url.TICKETS, data);
export const getTicketFilter = (changeUrl) =>
  get(`${url.TICKETS}${changeUrl.changeUrl}`);
export const getTicketDetail = (id) => get(`${url.TICKETS}${id}/`);
export const patchTicketUpdate = (id, data) =>
  patch(`${url.TICKETS}${id.id}/`, data);
export const deleteTicket = (id) => destroy(`${url.TICKETS}${id}/`);
export const getInvoiceDetail = (id) => get(`${url.INVOICES}${id}/detail/`);
export const getInvoice = (id) => get(`${url.INVOICES}${id}/`);
export const patchInvoiceUpdate = (id, data) =>
  patch(`${url.INVOICES}${id.id}/`, data);
export const postInvoiceCreate = (data) => post(url.INVOICES, data);
export const postConsignment = (data) => post(url.CONSIGNMENTS, data);

// Payment
export const getCheckList = () => get(url.CHECKS);
export const getCheckFilter = (changeUrl) =>
  get(`${url.CHECKS}${changeUrl.changeUrl}`);
export const getCheckDetail = (id) => get(`${url.CHECKS}${id}/`);
export const patchCheckUpdate = (id, data) =>
  patch(`${url.CHECKS}${id.id}/`, data);
export const getConsignmentList = () => get(url.CONSIGNMENTS);
export const getConsignmentFilter = (changeUrl) =>
  get(`${url.CONSIGNMENTS}${changeUrl.changeUrl}`);
export const getConsignmentDetail = (id) => get(`${url.CONSIGNMENTS}${id}/`);
export const patchConsignmentUpdate = (id, data) =>
  patch(`${url.CONSIGNMENTS}${id.id}/`, data);

export const postPayment = (data) => post(url.PAYMENTS, data);

// Confiscation
export const getProductList = () => get(url.PRODUCTS);
export const getCauseList = (product_id) =>
  get(`${url.CONFISCATION_CAUSE}${product_id}`);
export const postConfiscationCreate = (data) => post(url.CONFISCATIONS, data);
export const getSubproductTypeList = () => get(url.SUBPRODUCTS_TYPE);
export const postSubproductTypeList = (data) =>
  post(url.SUBPRODUCTS_TYPE, data);
export const postSubproductCreate = (data) => post(url.SUBPRODUCTS, data);

// Reports
export const getIncome = (changeUrl) => get(`${url.INCOME}${changeUrl}`);
export const getDaily = (changeUrl) => get(`${url.DAILY}${changeUrl}`);
export const getDailyList = (changeUrl) => get(`${url.DAILY_LIST}${changeUrl}`);
export const getVehicle = (changeUrl) => get(`${url.VEHICLE}${changeUrl}`);
export const getAccounts = (changeUrl) => get(`${url.ACCOUNT}${changeUrl}`);
export const getAccountDetail = (changeUrl) => get(`${url.ACCOUNT_DETAIL}${changeUrl}`);
export const getSubproduct = (changeUrl) =>
  get(`${url.SUBPRODUCT}${changeUrl}`);
export const getConsignment = (changeUrl) =>
  get(`${url.CONSIGNMENT}${changeUrl.changeUrl}`);
